import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface NotiSidebarEvent {
  open: boolean;
  payload?: any;
}

export interface PaymentConfirmedPayload {
  orderId?: string;
  paymentMode: string;
  transactionNo?: string;
  amount?: number;
  source?: 'create' | 'new' | string;
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private toggleSidebar = new Subject<boolean>();
  private overlaySidebarToggle = new Subject<boolean>();
  private toggleNotiSidebar = new Subject<NotiSidebarEvent>();
  private paymentConfirmedSubject = new Subject<PaymentConfirmedPayload>();

  toggleSidebar$ = this.toggleSidebar.asObservable();
  overlaySidebarToggle$ = this.overlaySidebarToggle.asObservable();
  toggleNotiSidebar$ = this.toggleNotiSidebar.asObservable();
  paymentConfirmed$ = this.paymentConfirmedSubject.asObservable();

  toggleSidebarSmallScreen(toggle: boolean): void {
    this.toggleSidebar.next(toggle);
  }

  overlaySidebartoggle(toggle: boolean): void {
    this.overlaySidebarToggle.next(toggle);
  }

  toggleNotificationSidebar(open: boolean, payload?: any): void {
    this.toggleNotiSidebar.next({ open, payload });
  }

  notifyPaymentConfirmed(payload: PaymentConfirmedPayload): void {
    this.paymentConfirmedSubject.next(payload);
  }
}
